module.exports = __webpack_public_path__ + "media/images/icon__link@3x-6dcc5e0c362a6f9434d8d8dff4770ccc.png";